<template>
  <v-btn
    :x-large="xLarge"
    :large="large"
    :disabled="disable || isOffline"
    :loading="loading"
    :color="`${color} darken-3`"
    :block="block"
    :outlined="outlined"
    :text="text"
  >
    <slot />
  </v-btn>
</template>

<script>
import { VueOfflineMixin } from 'vue-offline'
import { eventBus } from '@/main'
export default {
  name: 'AppButton',
  mixins: [VueOfflineMixin],
  props: {
    color: {
      type: String,
      default: 'primary'
    },
    disable: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    xLarge: {
      type: Boolean,
      default: false
    },
    block: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    text: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false
    }
  },
  mounted () {
    eventBus.$on('APP_BUTTON_START', callback => {
      this.loading = true
    })
    eventBus.$on('APP_BUTTON_END', () => {
      this.loading = false
    })
  }
}
</script>
